var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrillThrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.14746,
    y: 1,
    width: 16.0789,
    height: 16.0789,
    rx: 8.03946,
    stroke: "#667085",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18652 9.18896V11.189M15.1865 8.18896V11.189M12.1865 6.18896V11.189",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 19.2931C-0.0976311 19.6837 -0.0976311 20.3168 0.292893 20.7074C0.683417 21.0979 1.31658 21.0979 1.70711 20.7074L0.292893 19.2931ZM1.70711 20.7074L7.35677 15.0577L5.94256 13.6435L0.292893 19.2931L1.70711 20.7074Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillThrough);
export default __webpack_public_path__ + "static/media/drill-through.a1e97a94eb350eb9f1a551e3d0442361.svg";
export { ForwardRef as ReactComponent };